import axios from "axios";
import { get, post } from "../../xhr/api";

const ENV_URL = process.env.REACT_APP_BASE_URL;

const getMapLookup = async (url) => {
  return await get(url, {}, true);
};

export const getNationalities = () => {
  return get("api/category/nationalities", {}, false);
};

export const getOnlinePaymentNationalities = () => {
  return get("api/category/onlinePayment/nationalities", {}, false);
};
export const getGovernorates = () => {
  return get("api/category/governorates", {}, false);
};
export const getPaymentGovernorates = () => {
  return get("api/category/payment_governorates", {});
};
export const getDistricts = (id) => {
  return get(`api/category/districts/${id}`, {}, false);
};
export const getPaymentData = (id) => {
  return get(`api/payment/get_payment/${id}`, {}, true);
};
export const getPaymentReceipt = (id) => {
  return get(`api/payment/details/${id}`, {}, true);
};
export const getTaxDisputeReceipt = (id) => {
  return get(`api/tax-dispute/request-print-pdf/${id}`, {}, true);
};
export const getPaymentDistricts = (id) => {
  return get(`api/category/payment_districts/${id}`, {});
};
export const getPaymentCommitteeDistricts = (id) => {
  return get(`api/category/payment_committee_districts/${id}`, {});
};

export const getVillages = (id) => {
  return get(`api/category/villages/${id}`, {}, false);
};
export const getPaymentPlaces = () => {
  return get("api/category/payment_places", {});
};

export const getStreetVillage = (id) => {
  return get(`api/category/street/${id}/village`, {}, false);
};
export const getPaymentVillages = (id, has_other = false) => {
  if (has_other) {
    return get(`api/category/payment_villages/${id}?has_other=true`, {});
  } else {
    return get(`api/category/payment_villages/${id}`, {});
  }
};
export const getPaymentRegions = (id, has_other = false) => {
  if (has_other) {
    return get(`api/category/payment_regions/${id}?has_other=true`, {});
  } else {
    return get(`api/category/payment_regions/${id}`, {});
  }
};
export const getPaymentBuild = (id, has_other = false) => {
  if (has_other) {
    return get(`api/category/payment_build/${id}?has_other=true`, {});
  } else {
    return get(`api/category/payment_build/${id}`, {});
  }
};
export const getPaymentBuildByPlace = (id) => {
  return get(`api/category/payment_build_place/${id}`, {});
};
export const getPaymentPart = (id, strId) => {
  return get(`api/category/payment_part/${strId}?build_id=${id}`, {});
};
export const getPaymentPartByPlace = (id, region_id, has_other = false) => {
  if (has_other) {
    return get(
      `api/category/payment_part/${region_id}?build_id=${id}&has_other=true`,
      {},
    );
  } else {
    return get(`api/category/payment_part/${region_id}?build_id=${id}`, {});
  }
};
export const getFloorsByRealEstateId = (id) => {
  return get(`api/category/tax-appeal/appeal-floors-lookup/${id}`, {});
};
export const getPaymentUnit = (id, buil, strId) => {
  return get(`api/category/payment_unit/${id}/${strId}?build_id=${buil}`, {});
};

export const getAppealPaymentUnit = (id, real_estate_id) => {
  return get(`api/category/${real_estate_id}/${id}/units?has_other=true`, {});
};

export const getStreets = (id) => {
  return get(`api/category/streets/${id}`, {}, false);
};
export const getBirthsPlaces = () => {
  return get("api/category/governorates/out", {}, false);
};
export const getGenders = () => {
  return get("api/category/gender", {}, false);
};
export const getDeclarationProviderTypes = () => {
  return get("api/category/declaration-provider-type");
};
export const getDeclarationOwnerTypes = () => {
  return get("api/category/declaration-owner-type");
};
export const getDeclarationLegalTypes = () => {
  return get("api/category/legal-entity-type");
};
export const getDeclarationRealEstateTypes = () => {
  return get("api/category/declaration-real-estate-type");
};
export const getDeclarationGrageShare = () => {
  return get("api/category/declaration-garage-share");
};
export const getDeclarationExploitationTypes = (id) => {
  return get(`api/category/declaration-exploitation-type/${id}`);
};
export const getDeclarationResidentialTypes = () => {
  return get("api/category/declaration-residential-type");
};
export const getDeclarationOccupantTypes = () => {
  return get("api/category/declaration-occupant-type");
};
export const getDeclarationExtensions = () => {
  return get("api/category/declaration-extensions");
};
export const getDeclarationFloorDescriptions = () => {
  return get("api/category/floor-description");
};
export const getDeclarationCurencies = () => {
  return get("api/category/currency");
};
export const getDeclarationAreaTypes = () => {
  return get("api/category/area-type");
};
export const getDeclarationNonResidentailUseTypes = (exploitation_type) => {
  return get(`api/category/non-residential-occupant-type/${exploitation_type}`);
};
export const getDeclarationapiExtensionTypes = () => {
  return get("api/category/extension-type");
};
export const getDeclarationFactoryActivityTypes = () => {
  return get("api/category/factory-activity-type");
};
export const getDeclarationFactoryLandExploitationTypes = () => {
  return get("api/category/factory-land-exploitation-type");
};
export const getDeclarationFactoryBuildingExploitationTypes = () => {
  return get("api/category/factory-building-exploitation-type");
};
export const getDeclarationFactoryBuildingTypes = () => {
  return get("api/category/factory-building-type");
};
export const getDeclarationSeeViews = () => {
  return get("api/category/hotel-nile-mediterranean-view");
};
export const getDeclarationapiHotelUnitExploitationTypes = () => {
  return get("api/category/hotel-unit-exploitation-type");
};
export const getDeclarationPetroleumBildingExploitationTypes = () => {
  return get("api/category/petroleum-building-exploitation-type");
};
export const getDeclarationAirPortsLandExploitationTypes = () => {
  return get("api/category/airport-land-exploitation-type");
};
export const getDeclarationAirPortsBuildingExploitationTypes = () => {
  return get("api/category/airport-building-exploitation-type");
};
export const getDeclarationAirPortsUnitExploitationTypes = () => {
  return get("api/category/airport-unit-exploitation-type");
};
export const getDeclarationPortsLandExploitationTypes = () => {
  return get("api/category/port-land-exploitation-type");
};
export const getDeclarationPortsBuildingExploitationTypes = () => {
  return get("api/category/port-building-exploitation-type");
};
export const getDeclarationPortsUnitExploitationTypes = () => {
  return get("api/category/port-unit-exploitation-type");
};
export const getDeclarationFloors = () => {
  return get("api/category/floor");
};
export const getData = ($data) => {
  return post("api/payment/get_data", {}, $data, true);
};
export const sendData = ($data) => {
  return post("api/payment/send_data", {}, $data, true);
};
export const getPaymentUnitDetails = (id, buil, strId) => {
  return get(
    `api/category/payment_unit_details/${id}?build_id=${buil}&strId=${strId}`,
    {},
  );
};
export const getDeclarationRentValueTypes = () => {
  return get("api/category/rent_value_types");
};
export const getBuildingMaterialTypes = () => {
  return get("api/category/factory-building-material-type");
};
export const getDeclarationStatusList = () => {
  return get("api/category/declaration-status-list");
};
//tax dispute lookup
export const getTaxTypes = () => {
  return get("api/category/tax-dispute/tax-type");
};

export const getRequeststatuses = () => {
  return get("api/category/tax-dispute/tax-request-status");
};

export const getDisputeGovernorates = () => {
  return get("api/category/tax-dispute/governorates");
};

export const getDisputeDistricts = (goveId) => {
  return get(`api/category/tax-dispute/districts/${goveId}`);
};

export const getSubmitterCharacter = () => {
  return get("api/category/tax-dispute/submitter-character");
};

export const getExploitationType = () => {
  return get("api/category/tax-dispute/exploitation-type");
};

export const getDisputeReviewer = () => {
  return get("api/category/tax-dispute/dispute-reviewer");
};

export const getTaxPeriod = () => {
  return get("api/category/tax-dispute/tax-period");
};

export const getTaxTypesWithAll = () => {
  return get("api/category/tax-dispute/tax-type-with-all");
};

export const getUnderReviewRequestsCount = () => {
  return get("api/category/tax-dispute/request-count");
};

export const getTaxDisputeStoreAllLookups = () => {
  return get("api/category/tax-dispute/all-lookups");
};

export const getDsiputeDwonloadFiles = (id, field, declarationId) => {
  return get(`api/category/files/download/${field}`, {
    params: { id, ...(declarationId ? { declarationId } : {}) },
    responseType: "blob", // Handle binary data
  });
};
export const getDsiputePreviewFiles = (id, field, declarationId) => {
  return get(`api/category/files/preview/${field}`, {
    params: { id, ...(declarationId ? { declarationId } : {}) },
    responseType: "blob", // Handle binary data
  });
};

export const getFilePreview = (fileUrl) => {
  const filePath = fileUrl.replace(/^\/?public\/?/, "");

  return get(`api/files/${filePath}`, { responseType: "blob" });
};

export const getTaxAppealStoreAllLookups = (url) => {
  return get(url);
};

export const getTaxAppealListFilterAllLookups = () => {
  return get("api/category/tax-appeal/list-filter-all-lookups");
};

export const getUnifiedDeclarationAllLookups = (url) => {
  return get(url);
};

export const getUnifiedDeclarationAllDetails = (url) => {
  return get(url);
};

export const getDeclerationDistricts = (id) => {
  return get(
    `api/declaration-system/declaration-lookups/governorates/${id}/districts`,
    {},
  );
};

export const getDeclerationVillages = (id) => {
  return get(
    `api/declaration-system/declaration-lookups/districts/${id}/villages`,
    {},
  );
};

export const getDeclerationRegions = (id) => {
  return get(
    `api/declaration-system/declaration-lookups/villages/${id}/regions`,
    {},
  );
};

export const getMapGovernorates = () => {
  return getMapLookup("api/map/governorates");
};

export const getMapPoliceStationsByGovernorate = (governorateId) => {
  return getMapLookup(`api/map/governorates/${governorateId}/policeStation`);
};

export const getMapCitiesByGovernorate = (governorateId) => {
  return getMapLookup(`api/map/governorates/${governorateId}/cities`);
};

export const getMapDistrictsByCity = (cityId) => {
  return getMapLookup(`api/map/cities/${cityId}/districts`);
};

export const getMapMogawrasByDistrict = (districtId) => {
  return getMapLookup(`api/map/districts/${districtId}/mogwra`);
};

export const getMapVillagesByPoliceStation = (policeStationId) => {
  return getMapLookup(`api/map/policeStation/${policeStationId}/villages`);
};

export const getMapStreetsByPoliceStation = (policeStationId) => {
  return getMapLookup(`api/map/policeStation/${policeStationId}/streets`);
};

export const getSettlementsByGovID = (governorateId) => {
  return getMapLookup(`api/map/governorates/${governorateId}/settlement`);
};

export const getStaticGovernorate = () => {
  return getMapLookup(
    `/api/declaration-system/declaration-lookups/governorate-lookups`,
  );
};

export const getStaticPoliceStations = (governorateId) => {
  return getMapLookup(
    `/api/declaration-system/declaration-lookups/policeStation-lookups/${governorateId}`,
  );
};

export const getDeclerationRealEstates = (id) => {
  return get(
    `api/declaration-system/declaration-lookups/regions/${id}/real-estates`,
    {},
  );
};

export const getDeclerationFloorsByRealEstateId = (id) => {
  return get(
    `api/declaration-system/declaration-lookups/real-estate-floors?realEstateId=${id}`,
    {},
  );
};

export const getDeclerationUnitPerFloor = (realEstateId, floorId) => {
  return get(
    `api/declaration-system/declaration-lookups/real-estates/${realEstateId}/${floorId}/units`,
    {},
  );
};

export const getDeclerationListFilterAllLookups = (url) => {
  return get(url);
};

export const getDeclerationUnitList = (id, param) => {
  return get(`api/declaration-system/declarations/${id}?${param}`);
};

export const previewAndDownloadDeclerationFile = (url) =>
  get(`${url}`, { responseType: "blob" }, true);

export const getExploitationTypes = () => {
  return get("api/declaration-system/declaration-lookups/getExploitationTypes");
};

export const getStarRatings = () => {
  return get("api/declaration-system/declaration-lookups/getStarRatings");
};

export const getViewTypes = () => {
  return get("api/declaration-system/declaration-lookups/getViewTypes");
};

export const getPaymentReasons = () => {
  return get("api/declaration-system/declaration-lookups/payment_reasons")
}
